<!-- @format -->

<work-history>
  <div class="tab-menu margin-spacing-4_bottom">
    <ul class="tab-menu-list">
      <li
        each="{ tab in Tabs }"
        class="
          tab-menu-list-item
          {
          tab.name
          ==
          state.tabName
          ?
          'is-active'
          :''
          }
        "
      >
        <a class="js-tab" onclick="{ e => onTab(e, tab.name)}">
          経験した{ tab.label }
        </a>
      </li>
    </ul>
  </div>
  <!--/.tab-menu-->

  <div class="tab_contents { state.tabName=='industries' ? 'active' : '' }">
    <div
      if="{ state.master.industries }"
      class="contents_block skillsheet"
      is="industries"
      master="{ state.master.industries }"
      data="{ state.data.industries }"
      errors="{ state.errors }"
      on-update="{ onUpdateIndustries }"
      on-submit="{ onSubmit }"
    ></div>
  </div>

  <div class="tab_contents { state.tabName=='occupations' ? 'active' : '' }">
    <div
      if="{ state.master.occupations }"
      class="contents_block skillsheet"
      is="occupations"
      master="{ state.master.occupations }"
      data="{ state.data.occupations }"
      on-check="{ onUpdateOccupations }"
      on-submit="{ onSubmit }"
    ></div>
  </div>
  <!--/.table-nav_area-->

  <div class="box_flex03 margin-spacing-2_top">
    <div
      class="button button-secondary-large"
      type="button"
      value="登録する"
      onclick="{ onSubmit }"
    >
      登録する
    </div>
  </div>

  <script>
    import di from "dependeny-injection";
    import PublicInfoApi from "@model/skillsheet/public-info-api.js";
    import {
      Industries,
      Occupations,
    } from "@model/skillsheet/worker-history.js";
    import industries from "./industries.riot";
    import occupations from ".//occupations.riot";

    export default {
      components: { industries, occupations },
      Tabs: [
        { name: "industries", label: "業種・業界" },
        { name: "occupations", label: "職種" },
      ],
      state: {
        tabName: "industries",
        master: {},
        data: {
          industries: new Industries([]),
          occupations: {},
        },
        errors: {},
        isRegistered: false,
      },
      onBeforeMount() {
        this.PublicInfoApi = new PublicInfoApi();
      },
      async onMounted(state, props) {
        const res = await this.PublicInfoApi.request("work-history", "fetch");
        this.update({
          master: res.master,
          data: {
            industries: new Industries(res.data.industries),
            occupations: new Occupations(res.data.occupations),
          },
        });
        this.update({ isRegistered: this.hasData(this.state) });
      },
      hasData(state) {
        return (
          state.data.industries.hasChecked() ||
          state.data.occupations.hasChecked()
        );
      },
      onTab(e, tabName) {
        this.update({ tabName });
      },
      onUpdateIndustries(industries) {
        this.state.data.industries = industries;
        this.update({ data: this.state.data });
      },
      onUpdateOccupations(occupations) {
        this.state.data.occupations = occupations;
        this.update({ data: this.state.data });
      },
      async onSubmit() {
        const industries = this.state.data.industries.getPostData();
        const err = { data: {} };
        for (let i of industries) {
          if (i.id === "378" && !i.memo) {
            err.data.text = "入力に問題があります";
            err.data.errors = { 378: "入力してください" };
            this.error(err);
            return;
          }
        }
        this.update({ errors: {} });
        try {
          const res = await this.PublicInfoApi.request(
            "work-history",
            "register",
            {
              industries: JSON.stringify(
                this.state.data.industries.getPostData()
              ),
              occupations: JSON.stringify(
                this.state.data.occupations.getPostData()
              ),
            }
          );
          di.toast.push("職務経歴を更新しました", "success");
          // 新規登録イベント
          if (!this.state.isRegistered && this.hasData(this.state)) {
            this.update({ isRegistered: true });
            window.analytics.event("unlock_achievement", {
              achievement_id: "work_history_first_registration",
            });
          }
          return true;
        } catch (e) {
          if (e.message == "failed") {
            this.error(e);
          } else {
            di.toast.push(e, "negative");
          }
        }
      },
      error(e) {
        di.toast.push(e.data.text, "negative");
        this.update({ errors: e.data.errors });
        const container = window.document.querySelector(".container_contents");
        let error = this.$("div.error");
        while ((error = error.previousElementSibling)) {
          if (error.classList.contains("checkbox_list")) {
            break;
          }
        }
        const top = error.getBoundingClientRect().y + container.scrollTop;
        container.scrollTo({ top: top - 8, behavior: "smooth" });
      },
    };
  </script>
</work-history>
